export const headers = {
    initialHeaders : [
        {title: 'Nombre del empleado', field: 'nameEmployee', child: null},
        {title: 'Regional', field: 'regional', child: null},
        {title: 'Cargo solicitado', field: 'chargeRequested', child: null},
    ]
}

export const initialContract = {
    firstName: "",
    secondName: "",
    surname: "",
    secondSurname: "",
    documentType: "",
    document: "",
    dateBirth: "",
    charge: "",
    chargeId: "",
    regional: "",
    regionalId: "",
    nationality: "",
    cityBirth: "",
    departmentBirth: "",
    salary: "",
    paymentPeriod: "",
    workplace: "",
    hiringPlace: "",
    workStartDate: "",
    address: "",
    workEndDate: "",
    documentIssuancePlace: "",
    cityResidence: "",
    departmentResidence: "",
    profession: "",
    formationLevel: "",
    personalEmail: "",
    idContractTypeFormat: "",
    specialty: "",
    groupNumber: "",
    eps: "",
    arl: "",
    stratus: "",
    trainingInstitution: "",
    trainingInstitutionNit: null,
    isSena: "",
    trainingCenter: "",
};